// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Id3","placeholdersHeader":"styles_placeholdersHeader__V4vdV","editorStyle":"styles_editorStyle__1gDYt","placeholdersBox":"styles_placeholdersBox__1PtZI"};